/*
 * @Date: 2022-10-14 09:10:56
 * @LastEditTime: 2022-10-14 09:11:17
 * @Description:
 */
/*
 * @Date: 2022-08-10 18:17:26
 * @LastEditTime: 2022-08-16 10:13:54
 * @Description:
 */
import { net_common } from "@/api/http";
export const API_DisplayAccessLog = (...params) =>
  net_common.post("/api/STDSDC05C09/DisplayAccessLog", ...params);

export const API_DeleteAccessLog = (...params) =>
  net_common.post("/api/STDSDC05C09/DeleteAccessLog", ...params);

export const API_Research = (...params) =>
  net_common.post("/api/STDSDC05C09/Research", ...params);

export const API_GetSubPageID = (...params) =>
  net_common.post("/api/STDSDC05C09/SecurityManage", ...params);
